import * as CryptoJS from "crypto-js";

/**
 * Decode from base64 format
 * @param valueToDecode Value to decode
 * @returns Decoded string or null value
 */
export const decode = (valueToDecode: any): string | null => {
  try {
    if (valueToDecode != null) {
      return decodeURIComponent(atob(valueToDecode))!;
    } else {
      return null;
    }
  } catch (ex) {
    //TODO: - need to check why this clear
    localStorage.clear();
    console.error("Network Error", ex);
    return null;
  }
};

/**
 * Encode any values to base64 format
 * @param valueToEncode Value to encode
 * @returns Encoded string or null value
 */
export const encode = (valueToEncode: any): string => {
  if (valueToEncode != null) {
    return btoa(encodeURIComponent(valueToEncode))!;
  } else {
    return "";
  }
};

/**
 * Encrypt the text using cipher phrase
 * @param textToEncrypt Text to encrypt
 * @returns Encrypted string or null
 */
export const encrypt = (textToEncrypt: string): string | null => {
  try {
    const cipherPhrase = "b14ca5898a4e4133bbce2ea2315a1916"; //token
    const key = CryptoJS.enc.Utf8.parse(cipherPhrase);
    const iv = CryptoJS.enc.Utf8.parse("");
    const sha256 = CryptoJS.SHA256(key);
    const encrpt = CryptoJS.AES.encrypt(textToEncrypt.trim(), sha256, {
      keySize: 256 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrpt.toString();
  } catch (e) {
    console.error(`Network Error : ${e}`);
    return null;
  }
};

/**
 * Decrypt using cipher phrase
 * @param encryptedText Encrypted text. This will be the text to decrypt
 * @returns Decrypted string or null
 */
export const decrypt = (encryptedText: string): string | null => {
  try {
    const cipherPhrase = "b14ca5898a4e4133bbce2ea2315a1916"; //token
    const key = CryptoJS.enc.Utf8.parse(cipherPhrase);
    const iv = CryptoJS.enc.Utf8.parse("");
    const sha256 = CryptoJS.SHA256(key);
    const decrypted = CryptoJS.AES.decrypt(encryptedText.trim(), sha256, {
      keySize: 256 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (e) {
    console.error(`Network Error: ${e}`);
    return null;
  }
};
